import { sb } from '../supabase';
import { fetchConversationMessages } from './consoleConversations';
import { translateText } from './aiTranslate';
import { cardContent, cardMessage, latestProductRef, latestTraderQuestion, waLink } from './traderCard';

// Everything the trader card needs, read fresh for one factory conversation.
// Admin-only by construction: the thread comes through admin_conversation_messages
// (is_admin_user() inside), and the card is only offered in /admin2.
export async function loadTraderCard({ factoryId, trader }) {
  const [facRes, profRes, thread] = await Promise.all([
    sb.from('factory_directory')
      .select('id, company_name, company_name_latin, claim_slug, claimed_at, wa_phone_e164')
      .eq('id', factoryId).maybeSingle(),
    // full_name only — the card keeps the FIRST name and nothing else.
    sb.from('profiles').select('full_name').eq('id', trader).maybeSingle(),
    fetchConversationMessages({ channel: 'factory', trader, counterpart: factoryId }),
  ]);
  if (facRes.error) throw facRes.error;
  if (profRes.error) console.error('[traderCard] trader read failed:', profRes.error.message || profRes.error);
  const factory = facRes.data;
  if (!factory) throw new Error('factory not found');

  const ref = latestProductRef(thread);
  const question = latestTraderQuestion(thread, trader);

  let nameZh = '';
  if (ref?.id) {
    const { data, error } = await sb.from('factory_products').select('name_zh').eq('id', ref.id).maybeSingle();
    if (error) console.error('[traderCard] product read failed:', error.message || error);
    nameZh = data?.name_zh || '';
  }

  // maabar-ai chat_translation, through the shared helper. It never throws;
  // on failure the card goes out without the Chinese line and says so.
  let questionZh = '';
  let translationFailed = false;
  if (question) {
    const r = await translateText(question, 'zh');
    if (r?.error) { translationFailed = true; console.error('[traderCard] translation failed:', r.error); }
    else if (r?.translated && r.translated !== question) questionZh = r.translated;
  }

  const content = cardContent({
    fullName: profRes.data?.full_name, question, questionZh, ref, nameZh, claimSlug: factory.claim_slug,
  });
  const message = cardMessage(content);
  return {
    factory,
    content,
    message,
    waUrl: waLink(factory.wa_phone_e164, message),
    translationFailed,
    hasProduct: !!ref,
  };
}

// Is this catalogue factory claimed? true / false, or null when it cannot be
// read (the card button then stays hidden rather than guessing).
export async function fetchFactoryClaimed(factoryId) {
  if (!factoryId) return null;
  const { data, error } = await sb.from('factory_directory').select('claimed_at').eq('id', factoryId).maybeSingle();
  if (error) { console.error('[traderCard] claim state failed:', error.message || error); return null; }
  return data ? !!data.claimed_at : null;
}
